<template>
  <div class="content-builder">

    <div class="form-group">
      <QuillEditor :toolbar="toolbarOpts" :modules="editorModules" theme="snow" :contentType="'html'" v-model:content="content.text"/>
    </div>

    <div class="form-group">
      <div class="actions">
        <div class="action-item">
          <button class="btn btn-default" type="button" :disabled="limitReached" v-show="!limitReached" @click="addEvent"><i class="fa fa-plus"></i> Add Event</button>
          <small class="text-muted" v-show="limitReached">This page is limited to a total of {{ limit }} possible events.</small>
        </div>
        <div class="action-item">
          <input id="show-0-val-outcomes" type="checkbox" v-model="content.showOutcomeOfZero">
          <label for="show-0-val-outcomes" class="control-label">Show outcomes with value of 0</label>
        </div>
      </div>

      <div class="content-list">

        <div v-for="(event, index) in content.events" :key="index" v-cloak class="card content-list-item">
          <div class="card-body">
            <div class="form-group">
              <label for="text" class="control-label">Event Text</label>
              <textarea class="form-control" v-model="event.text"></textarea>
            </div>
            <div class="form-group row">
              <div class="col-sm-6">
                <label for="event-image" class="control-label">Event Image</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <a :data-input="'event-image-' + index" class="btn btn-primary text-white" data-lfm="image">
                      <i class="fa fa-image-o"></i> Choose
                    </a>
                  </div>
                  <input :id="'event-image-' + index" type="text" class="form-control" v-model.lazy="event.image">
                </div>
              </div>
              <div class="col-sm-3">
                <label for="flow" class="control-label">Flow Hook</label>
                <input type="text" class="form-control" v-model="event.flow"
                       :placeholder="'choice-' + (index + 1)">
              </div>
              <div class="col-sm-3">
                  <label for="flow" class="control-label">Outcome Trigger</label>
                  <input type="text" class="form-control" v-model="event.trigger"
                        :placeholder="'event-' + (index + 1)">
              </div>
            </div>
            <div class="form-group card-metrics">
              <label for="metrics" class="control-label">Meter Effects</label>
              <div class="row">
                <div v-for="meter in event.meters" :key="meter.id" class="col-sm">
                  <span :class="['badge', 'badge-primary', meter.id]">{{ meter.id }}</span>
                  <input :id="meter.id" type="number" class="form-control" v-model="meter.value">
                </div>
                <div class="col-sm offset-sm-3">
                  <label class="control-label">&nbsp;</label>
                  <button type="button" class="btn btn-danger btn-block" @click="remove(event, index)">Remove</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { defaultMeters } from '../../../common/metrics'
  import layoutMixin from '../../mixins/layout'
  import limitedMixin from '../../mixins/limited'
  import { EDITOR_CONFIG_BUTTONS_FULL } from '../../../common/constants'
  import { QuillEditor } from '@vueup/vue-quill'
  import '@vueup/vue-quill/dist/vue-quill.snow.css'

  export default {
    components: {
      QuillEditor
    },
    mixins: [layoutMixin, limitedMixin],
    data() {
      const content = _.cloneDeep(this.source)
      const filled = _.defaults(content, {
        events: [{}, {}]
      })

      // pre-fill with default data
      filled.events.forEach((event) => {
        if (!event.meters || !event.meters.length) {
          event.meters = defaultMeters()
        }
      })

      if (!_.get(content, 'showOutcomeOfZero')) {
        content.showOutcomeOfZero = false;
      }

      return {
        content: filled,
        toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL
      }
    },
    computed: {
      limitedItem() {
        return this.content.events
      }
    },
    methods: {
      setContent() {
        console.log('RandomEvent::setContent')
      },
      getValue() {

        _.each(this.content.events, (event, key) => {
          this.content.events[key].image = $("#event-image-" + key).val()
        })

        return this.content
      },
      remove(item, index) {
        this.content.events.splice(index, 1)
      },
      addEvent() {
        this.content.events.unshift({
          meters: defaultMeters()
        })

        this.$nextTick(() => {
          $(this.$el).find('[data-lfm]').filemanager('image', {prefix: '/filemanager'})
        })
      }
    }
  }
</script>
